import { Header } from "../components/landing/Header";
import { Footer } from "../components/landing/Footer";
import { useSeo } from "../hooks/useSeo";

export default function CookiePage() {
  useSeo({
    title: "Cookie Policy | iQ Hub",
    description:
      "Learn how iQ Hub uses cookies and similar tracking technologies to enhance your browsing experience, understand site usage, and improve our website.",
    ogTitle: "Cookie Policy | iQ Hub",
    ogDescription:
      "Learn how iQ Hub uses cookies and similar tracking technologies to enhance your browsing experience, understand site usage, and improve our website.",
    ogUrl: "https://www.iq-hub.com/cookie-policy",
    canonical: "https://www.iq-hub.com/cookie-policy",
  });

  return (
    <div className="min-h-screen bg-[#FAFAF8]">
      <Header />
      
      <main className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h1 className="text-4xl lg:text-5xl font-bold text-[#0F172A] mb-8">
            Cookie Policy
          </h1>
          
          <div className="prose prose-lg max-w-none text-[#475569]">
            <p className="mb-8 text-lg">
              This Cookie Policy explains how IQ International Pte. Ltd ("IQ Hub," "we," "us," or "our") uses cookies and similar tracking technologies on our website.
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#0F172A] mb-4">What Are Cookies?</h2>
              <p>
                Cookies are small text files that are stored on your device (computer, tablet, or mobile) when you visit a website. They help the website remember your actions and preferences over time.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Types of Cookies We Use</h2>
              
              <div className="mb-6">
                <h3 className="text-xl font-semibold text-[#0F172A] mb-2">1. Essential Cookies</h3>
                <p>
                  These cookies are necessary for the website to function properly. They enable basic features like page navigation and access to secure areas. The website cannot function properly without these cookies.
                </p>
              </div>
              
              <div className="mb-6">
                <h3 className="text-xl font-semibold text-[#0F172A] mb-2">2. Analytics Cookies</h3>
                <p>
                  These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve the website's performance and user experience.
                </p>
              </div>
              
              <div className="mb-6">
                <h3 className="text-xl font-semibold text-[#0F172A] mb-2">3. Functional Cookies</h3>
                <p>
                  These cookies allow the website to remember choices you make (such as your language preference) and provide enhanced, personalized features.
                </p>
              </div>
              
              <div className="mb-6">
                <h3 className="text-xl font-semibold text-[#0F172A] mb-2">4. Marketing Cookies</h3>
                <p>
                  These cookies are used to track visitors across websites. They are used to display ads that are relevant and engaging for the individual user.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Managing Your Cookie Preferences</h2>
              <p className="mb-4">Most web browsers allow you to control cookies through their settings. You can:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Delete all cookies from your browser</li>
                <li>Block all cookies from being set</li>
                <li>Allow only certain cookies</li>
                <li>Set your browser to notify you when a cookie is being set</li>
              </ul>
              <p className="mt-4">
                Please note that blocking certain cookies may impact your experience on our website.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Your Consent</h2>
              <p>
                By continuing to use our website, you consent to our use of cookies as described in this policy. You can withdraw your consent at any time by adjusting your browser settings.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Third-Party Cookies</h2>
              <p>
                Some cookies on our site are set by third-party services that appear on our pages. We do not control the dissemination of these cookies.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Changes to This Policy</h2>
              <p>
                We may update this Cookie Policy from time to time. Any changes will be posted on this page.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Contact Us</h2>
              <p className="mb-4">
                If you have questions about our use of cookies, please contact us at <a href="mailto:info@iq-hub.com" className="text-[#C8A951] hover:underline">info@iq-hub.com</a>.
              </p>
              <p className="text-[#64748B]">
                IQ International Pte. Ltd<br />
                8 Marina View, #07-04 Asia Square Tower 1<br />
                Singapore, 018960
              </p>
            </section>

            <div className="mt-12 pt-8 border-t border-[#E2E8F0]">
              <p className="text-sm text-[#64748B]">
                Last updated: February 2026
              </p>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
